import { render, staticRenderFns } from "./SupplierWork.vue?vue&type=template&id=75fa257e&scoped=true&lang=pug&"
import script from "./SupplierWork.vue?vue&type=script&lang=ts&"
export * from "./SupplierWork.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierWork.vue?vue&type=style&index=0&id=75fa257e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fa257e",
  null
  
)

export default component.exports